import type {
  CreateAccountLoginCodeReply,
  CreateAccountLoginCodeRequest,
  DeleteAccountLoginCodeReply,
  DeleteAccountLoginCodeRequest,
  GetAccountLoginCodeReply,
  GetAccountLoginCodeRequest,
  GetAccountLoginCodeSettingsReply,
  GetAccountLoginCodeSettingsRequest,
  ListAccountLoginCodesReply,
  ListAccountLoginCodesRequest,
  UpdateAccountLoginCodeExpiryReply,
  UpdateAccountLoginCodeExpiryRequest,
  UpdateAccountLoginCodeSettingsReply,
  UpdateAccountLoginCodeSettingsRequest,
} from '@/types';
import api from './api';

export const loginCodeApi = {
  createAccountLoginCode: async (
    data: CreateAccountLoginCodeRequest,
  ): Promise<CreateAccountLoginCodeReply> => {
    return api.post('/api/v1/account-login-codes', data);
  },

  getAccountLoginCode: async (
    data: GetAccountLoginCodeRequest,
  ): Promise<GetAccountLoginCodeReply> => {
    return api.get(`/api/v1/account-login-codes/${data.id}`);
  },

  listAccountLoginCodes: async (
    params: ListAccountLoginCodesRequest,
  ): Promise<ListAccountLoginCodesReply> => {
    return api.get('/api/v1/account-login-codes', { params });
  },

  deleteAccountLoginCode: async (
    data: DeleteAccountLoginCodeRequest,
  ): Promise<DeleteAccountLoginCodeReply> => {
    return api.delete(`/api/v1/account-login-codes/${data.id}`, { data });
  },

  updateAccountLoginCodeExpiry: async (
    data: UpdateAccountLoginCodeExpiryRequest,
  ): Promise<UpdateAccountLoginCodeExpiryReply> => {
    return api.post(`/api/v1/account-login-codes/${data.id}/expiry`, data);
  },

  getAccountLoginCodeSettings: async (
    params: GetAccountLoginCodeSettingsRequest,
  ): Promise<GetAccountLoginCodeSettingsReply> => {
    return api.get('/api/v1/account-login-code-settings', { params });
  },

  updateAccountLoginCodeSettings: async (
    data: UpdateAccountLoginCodeSettingsRequest,
  ): Promise<UpdateAccountLoginCodeSettingsReply> => {
    return api.post('/api/v1/account-login-code-settings', data);
  },
};
